export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  imageUrl: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const categories: Category[] = [
  {
    slug: 'latest-address',
    name: '最新地址',
    icon: 'ri-links-line',
    description: 'jmcomic-zzz.one最新可用访问地址与镜像站点汇总',
  },
  {
    slug: 'access-guide',
    name: '访问指南',
    icon: 'ri-guide-line',
    description: '详细访问方法与网络配置指南，确保稳定连接',
  },
  {
    slug: 'popular-recommend',
    name: '热门推荐',
    icon: 'ri-fire-line',
    description: '当前最受欢迎的JM漫画作品推荐与排行',
  },
  {
    slug: 'new-releases',
    name: '最新上架',
    icon: 'ri-rocket-line',
    description: 'JM漫画平台最新上线作品一览',
  },
  {
    slug: 'genres',
    name: '分类浏览',
    icon: 'ri-grid-line',
    description: '按题材类型浏览漫画：热血、恋爱、悬疑、搞笑等',
  },
  {
    slug: 'faq-help',
    name: '帮助中心',
    icon: 'ri-question-line',
    description: '常见问题解答与使用帮助文档',
  },
];

export const articles: Article[] = [
  {
    slug: 'jmcomic-zzz-one-latest-url-2026',
    title: 'jmcomic-zzz.one 2026年最新可用地址汇总',
    excerpt: '本文整理了jmcomic-zzz.one在2026年所有经过验证的可用访问地址，包括主域名与备用镜像站，帮助您快速连接到JM漫画平台。',
    content: `<h2>jmcomic-zzz.one 最新地址概览</h2>
<p>随着网络环境的变化，JM漫画的访问地址可能会定期更新。本文持续追踪并更新jmcomic-zzz.one的最新可用域名与镜像站地址，确保您能够稳定访问。</p>

<h3>主域名</h3>
<p>当前主域名：<strong>jmcomic-zzz.one</strong> - 这是JM漫画的官方主要入口，推荐优先使用此地址访问。</p>

<h3>备用镜像站</h3>
<p>当主域名访问不稳定时，您可以通过以下镜像站点访问JM漫画：</p>
<ul>
<li>镜像站一：jmcomic-mirror-1.xyz</li>
<li>镜像站二：jmcomic-mirror-2.top</li>
<li>镜像站三：jmcomic-backup.site</li>
</ul>

<h3>如何验证地址有效性</h3>
<p>建议您收藏本导航页面，我们将持续更新最新可用地址。同时，您也可以关注JM漫画官方社交媒体账号获取最新域名变更通知。</p>

<h3>注意事项</h3>
<p>请务必通过官方渠道获取访问地址，避免使用来路不明的第三方链接，以保障您的账号安全与隐私。</p>`,
    category: 'latest-address',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20illustration%20style%2C%20warm%20toned%20abstract%20background%20with%20Japanese%20manga%20aesthetic%2C%20soft%20gradient%20with%20subtle%20ink%20wash%20texture%2C%20minimalist%20and%20clean%20composition%2C%20artistic%20atmosphere&width=800&height=400&seq=article-latest-url&orientation=landscape',
    date: '2026-08-01',
    readTime: '5分钟',
    tags: ['最新地址', '镜像站', '域名'],
  },
  {
    slug: 'jmcomic-access-method-guide',
    title: 'JM漫画完整访问方法教程（2026版）',
    excerpt: '从零开始的JM漫画访问教程，涵盖网络配置、浏览器设置、移动端访问等全方位指南。',
    content: `<h2>JM漫画访问方法完整指南</h2>
<p>无论您是初次接触JM漫画的新用户，还是遇到访问困难的老用户，本指南都将为您提供详细的访问方法说明。</p>

<h3>一、PC端访问方法</h3>
<p>在电脑浏览器中直接输入官方地址 <strong>jmcomic-zzz.one</strong> 即可访问。推荐使用Chrome、Edge或Firefox浏览器以获得最佳体验。</p>

<h3>二、移动端访问方法</h3>
<p>在手机浏览器中输入相同地址即可访问移动版JM漫画。移动版针对小屏幕进行了优化，阅读体验流畅。</p>

<h3>三、网络优化建议</h3>
<p>如果遇到访问缓慢的情况，建议：</p>
<ul>
<li>切换网络环境（WiFi与移动数据之间切换尝试）</li>
<li>清除浏览器缓存与Cookie</li>
<li>尝试使用备用镜像站地址</li>
<li>更换DNS服务器为公共DNS（如8.8.8.8或114.114.114.114）</li>
</ul>

<h3>四、常见连接问题排查</h3>
<p>如遇到无法访问的情况，请先确认：</p>
<ul>
<li>网络连接是否正常</li>
<li>地址是否输入正确</li>
<li>是否被本地网络防火墙拦截</li>
</ul>`,
    category: 'access-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20illustration%20style%2C%20warm%20toned%20abstract%20background%20with%20Japanese%20manga%20aesthetic%2C%20soft%20gradient%20with%20subtle%20ink%20wash%20texture%2C%20minimalist%20and%20clean%20composition%2C%20artistic%20atmosphere&width=800&height=400&seq=article-access-guide&orientation=landscape',
    date: '2026-07-28',
    readTime: '8分钟',
    tags: ['访问方法', '教程', '网络配置'],
  },
  {
    slug: 'jmcomic-top-10-popular-manga-2026',
    title: '2026年JM漫画平台热门作品TOP10推荐',
    excerpt: '盘点2026年JM漫画平台上最受读者欢迎的十部热门漫画作品，涵盖多种题材类型。',
    content: `<h2>2026年JM漫画热门作品TOP10</h2>
<p>基于平台阅读量与用户评分数据，我们整理了2026年度最受欢迎的十部漫画作品。</p>

<h3>TOP 1 - 星辰变</h3>
<p>玄幻修仙题材的巅峰之作，精美的画风与宏大的世界观吸引了大量读者。</p>

<h3>TOP 2 - 都市猎魔人</h3>
<p>都市异能题材，紧张刺激的剧情节奏让人欲罢不能。</p>

<h3>TOP 3 - 逆天邪神</h3>
<p>热血战斗类漫画，主角成长路线清晰，战斗场面极具冲击力。</p>

<h3>TOP 4 - 甜心陷阱</h3>
<p>恋爱题材人气作品，甜蜜中带着反转，深受女性读者喜爱。</p>

<h3>TOP 5 - 诡案实录</h3>
<p>悬疑推理类漫画，每个案件都环环相扣，烧脑程度满分。</p>

<h3>TOP 6 - 龙族传说</h3>
<p>奇幻冒险题材，龙与骑士的史诗故事，画面震撼。</p>

<h3>TOP 7 - 我的女友是妖怪</h3>
<p>搞笑恋爱类作品，轻松幽默的日常中穿插温情桥段。</p>

<h3>TOP 8 - 末日生存指南</h3>
<p>末世生存题材，紧张刺激的求生剧情与人性刻画。</p>

<h3>TOP 9 - 剑道通神</h3>
<p>武侠修仙类漫画，传统武侠元素与现代审美完美结合。</p>

<h3>TOP 10 - 星河舰队</h3>
<p>科幻题材力作，宏大的宇宙舞台与精良的画面制作。</p>`,
    category: 'popular-recommend',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20illustration%20style%2C%20warm%20toned%20abstract%20background%20with%20Japanese%20manga%20aesthetic%2C%20soft%20gradient%20with%20subtle%20ink%20wash%20texture%2C%20minimalist%20and%20clean%20composition%2C%20artistic%20atmosphere&width=800&height=400&seq=article-top10&orientation=landscape',
    date: '2026-08-05',
    readTime: '10分钟',
    tags: ['热门推荐', '排行', 'TOP10'],
  },
  {
    slug: 'jmcomic-new-manga-august-2026',
    title: 'JM漫画2026年8月最新上架作品一览',
    excerpt: '本月JM漫画平台新上架了多部精彩作品，涵盖热血、恋爱、奇幻等多种题材，快来看看有哪些新作值得追。',
    content: `<h2>2026年8月新上架作品</h2>
<p>每月JM漫画都会上线大量新作品，以下是本月精选推荐。</p>

<h3>热血新作</h3>
<ul>
<li>《武道至尊》- 少年踏上武道巅峰的热血故事</li>
<li>《烈焰战场》- 战争题材热血漫画，场面宏大</li>
</ul>

<h3>恋爱新作</h3>
<ul>
<li>《樱花下的约定》- 校园纯爱漫画，画风唯美</li>
<li>《总裁的契约情人》- 都市言情题材人气新作</li>
</ul>

<h3>奇幻新作</h3>
<ul>
<li>《异世界食堂》- 美食与奇幻结合的治愈系作品</li>
<li>《魔法学院日常》- 轻松搞笑的魔法校园故事</li>
</ul>

<h3>悬疑新作</h3>
<ul>
<li>《第13号房间》- 密室逃脱题材悬疑漫画</li>
<li>《心理师》- 心理犯罪题材，剧情烧脑</li>
</ul>`,
    category: 'new-releases',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20illustration%20style%2C%20warm%20toned%20abstract%20background%20with%20Japanese%20manga%20aesthetic%2C%20soft%20gradient%20with%20subtle%20ink%20wash%20texture%2C%20minimalist%20and%20clean%20composition%2C%20artistic%20atmosphere&width=800&height=400&seq=article-new-aug&orientation=landscape',
    date: '2026-08-03',
    readTime: '6分钟',
    tags: ['最新上架', '新作', '八月'],
  },
  {
    slug: 'jmcomic-genre-guide',
    title: 'JM漫画分类浏览指南：找到你喜欢的漫画类型',
    excerpt: 'JM漫画平台拥有丰富的漫画分类体系，本指南帮您快速了解各分类特点，精准找到感兴趣的漫画作品。',
    content: `<h2>JM漫画分类体系详解</h2>
<p>JM漫画平台提供完善的分类体系，方便用户按喜好浏览。</p>

<h3>热血类</h3>
<p>以战斗、成长为主题的漫画，代表作品有《星辰变》、《逆天邪神》等。适合喜欢激烈打斗和主角成长故事的读者。</p>

<h3>恋爱类</h3>
<p>以爱情故事为主线，包括校园恋爱、都市言情等多种子类型。画风通常较为精致，情感描写细腻。</p>

<h3>悬疑类</h3>
<p>以推理、解密为核心的漫画类型，剧情紧凑、反转频繁。适合喜欢动脑思考的读者。</p>

<h3>搞笑类</h3>
<p>轻松幽默的日常喜剧或搞笑冒险故事，适合放松心情阅读。</p>

<h3>奇幻类</h3>
<p>包含魔法、异世界、神话等元素的幻想题材漫画，世界观设定丰富多样。</p>

<h3>科幻类</h3>
<p>以未来科技、外星文明、机甲等为主题的漫画类型。</p>

<h3>恐怖类</h3>
<p>以惊悚、恐怖元素为主的漫画，氛围营造出色。</p>`,
    category: 'genres',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20illustration%20style%2C%20warm%20toned%20abstract%20background%20with%20Japanese%20manga%20aesthetic%2C%20soft%20gradient%20with%20subtle%20ink%20wash%20texture%2C%20minimalist%20and%20clean%20composition%2C%20artistic%20atmosphere&width=800&height=400&seq=article-genre-guide&orientation=landscape',
    date: '2026-07-25',
    readTime: '7分钟',
    tags: ['分类浏览', '题材', '指南'],
  },
  {
    slug: 'jmcomic-faq-collection',
    title: 'JM漫画常见问题解答合集',
    excerpt: '汇总用户最常问的问题，包括账号注册、会员充值、阅读设置、下载功能等方面的详细解答。',
    content: `<h2>JM漫画常见问题解答</h2>

<h3>Q: 如何注册JM漫画账号？</h3>
<p>进入官网后点击右上角"注册"按钮，按照提示输入邮箱或手机号即可完成注册。注册过程简单快捷，无需实名认证。</p>

<h3>Q: 忘记密码怎么办？</h3>
<p>在登录页面点击"忘记密码"，通过注册邮箱或手机号接收验证码后即可重置密码。</p>

<h3>Q: JM漫画是否需要付费？</h3>
<p>JM漫画提供大量免费漫画内容，部分精品内容可能需要购买会员或单独付费。会员价格实惠，支持多种支付方式。</p>

<h3>Q: 如何下载漫画离线阅读？</h3>
<p>在JM漫画App中，打开任意漫画详情页，点击"下载"按钮即可将章节缓存到本地，方便无网络时阅读。</p>

<h3>Q: 阅读记录会同步吗？</h3>
<p>登录账号后，您的阅读记录、收藏和书签会自动云端同步，换设备登录后也可以继续阅读。</p>

<h3>Q: 为什么图片加载很慢？</h3>
<p>可能与当前网络环境有关。建议切换网络或尝试使用镜像站点。也可以调整阅读设置为"标清模式"以加快加载速度。</p>

<h3>Q: 如何联系客服？</h3>
<p>您可以通过官网底部的"联系我们"页面提交工单，或在App内直接联系在线客服。</p>`,
    category: 'faq-help',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20illustration%20style%2C%20warm%20toned%20abstract%20background%20with%20Japanese%20manga%20aesthetic%2C%20soft%20gradient%20with%20subtle%20ink%20wash%20texture%2C%20minimalist%20and%20clean%20composition%2C%20artistic%20atmosphere&width=800&height=400&seq=article-faq&orientation=landscape',
    date: '2026-07-20',
    readTime: '6分钟',
    tags: ['常见问题', 'FAQ', '帮助'],
  },
];

export const faqs = [
  {
    question: 'jmcomic-zzz.one 是什么？',
    answer: 'jmcomic-zzz.one 是JM漫画的官方入口导航页面，为用户提供JM漫画平台的最新访问地址、镜像站点列表、访问方法指南以及常见问题解答，帮助用户快速稳定地连接到JM漫画平台。',
  },
  {
    question: 'jmcomic-zzz.one 的最新地址是什么？',
    answer: '当前最新主域名即为 jmcomic-zzz.one。当主域名访问不畅时，我们还提供多个备用镜像站地址。建议收藏本导航页面以获取实时更新的地址信息。',
  },
  {
    question: '如何确保稳定访问JM漫画？',
    answer: '建议您：1）收藏本导航页面作为入口；2）保存多个镜像站地址备用；3）关注官方社交媒体获取最新域名变更通知；4）在遇到访问问题时尝试切换网络或DNS服务器。',
  },
  {
    question: 'JM漫画是否需要注册账号？',
    answer: '浏览漫画内容一般不需要注册，但如果要使用收藏、评论、订阅等功能，建议注册一个免费账号。注册过程简单，支持邮箱或手机号注册。',
  },
  {
    question: 'JM漫画支持哪些设备访问？',
    answer: 'JM漫画支持PC端（Windows/Mac浏览器）、移动端（手机浏览器/官方App）以及平板设备访问。移动端有针对小屏幕优化的专属界面，阅读体验流畅。',
  },
  {
    question: 'JM漫画的会员有什么权益？',
    answer: '会员用户可享受无广告阅读、高清画质、提前解锁新章节、专属头像框等多项特权。会员价格实惠，提供月度、季度和年度多种订阅方案。',
  },
  {
    question: '遇到无法访问的问题怎么解决？',
    answer: '如遇访问问题，请依次尝试：1）检查网络连接；2）清除浏览器缓存；3）更换DNS服务器；4）使用备用镜像站地址；5）联系客服获取帮助。',
  },
  {
    question: 'JM漫画上的内容是否正版？',
    answer: 'JM漫画平台致力于提供优质漫画内容，与多家版权方合作。建议用户在官方平台阅读漫画以支持创作者，获得最佳的阅读体验。',
  },
];